import { jsx as _jsx } from "react/jsx-runtime";
import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { VoiceToVoiceModalLoader } from '#pplx/frontend/apps/ask/multimodal/voice/components/full/VoiceToVoiceModalLoader.js';
import { useWebVoiceContext } from '#pplx/frontend/apps/ask/multimodal/voice/launcher/WebVoiceContext.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { useCallback } from 'react';
const VoiceToVoiceModal = Dynamic(async () => {
    const { VoiceToVoiceModal } = await import('#pplx/frontend/apps/ask/multimodal/voice/components/full/VoiceToVoiceModal.js');
    return { default: VoiceToVoiceModal };
}, { loading: () => _jsx(VoiceToVoiceModalLoader, {}) });
export function useOpenWebVoice() {
    const { openModal } = useModalContext();
    const openOverlay = useWebVoiceContext()?.open;
    return useCallback(() => {
        if (openOverlay) {
            openOverlay();
            return;
        }
        openModal(VoiceToVoiceModal, {}, { replace: true });
    }, [openModal, openOverlay]);
}
//# sourceMappingURL=useOpenWebVoice.js.map